import Vue from 'vue';
import { isEqual } from 'lodash';
import ProgressStates from '../../../helpers/lists/progressStates';
import SBIconList from '../../../helpers/lists/sb-icon-list';
import { memberTypes, memberFilterMethods } from '../../../helpers/enums/memberTypes.enum';

const mutations = {
  ADD_MEMBER_TO_BUSINESS(state, payload) {
    const targetMember = state.organisationMembersLookup[payload.user_uid];
    if (targetMember && !targetMember.businesses.includes(payload.business_uid)) {
      targetMember.businesses.push(payload.business_uid);
    }

    const targetMemberInOrganisation = state.organisationMembers.find(m => m.id === payload.user_uid);
    if (targetMemberInOrganisation && !targetMemberInOrganisation.businesses.includes(payload.business_uid)) {
      targetMemberInOrganisation.businesses.push(payload.business_uid);
    }

    if (payload.user_uid === payload.me.id) {
      let targetNumber;
      if (state.organisationNumbers) {
        targetNumber = state.organisationNumbers.find(n => n.id === payload.business_uid);
      }
      if (targetNumber) {
        if (!state.currentOrganisation.businesses.find(b => b.id === targetNumber.id)) {
          state.currentOrganisation.businesses.push(targetNumber);
        }
      }

      if (!state.currentOrganisationBusinessIds.includes(payload.business_uid)) {
        state.currentOrganisationBusinessIds.push(payload.business_uid);
      }
    }
  },
  REMOVE_MEMBER_FROM_BUSINESS(state, payload) {
    const targetMember = state.organisationMembersLookup[payload.user_uid];
    targetMember.businesses = [...targetMember.businesses.filter(business => business !== payload.business_uid)];

    const targetMemberInOrganisation = state.organisationMembers.find(m => m.id === payload.user_uid);
    targetMemberInOrganisation.businesses = [...targetMemberInOrganisation.businesses.filter(business => business !== payload.business_uid)];

    if (payload.user_uid === payload.me.id) {
      const targetNumberIndex = state.currentOrganisation.businesses.findIndex(b => b.id === payload.business_uid);

      if (targetNumberIndex >= 0) {
        state.currentOrganisation.businesses.splice(targetNumberIndex, 1);
      }

      if (state.currentOrganisationBusinessIds.includes(payload.business_uid)) {
        state.currentOrganisationBusinessIds = state.currentOrganisationBusinessIds.filter(bId => bId !== payload.business_uid);
      }
    }
  },
  LOADING_ORGANISATION_NUMBERS(state, flag) {
    state.loadingOrganisationNumbers = flag;
  },
  SET_ORGANISATION_NUMBERS(state, payload) {
    state.organisationNumbers = payload;
  },
  SET_ORGANISATION_NUMBER(state, payload) {
    payload.forEach((number) => {
      const targetBusinessIndex = state.currentOrganisation.businesses.findIndex(b => b.id === number.id);
      if (targetBusinessIndex >= 0) {
        state.currentOrganisation.businesses[targetBusinessIndex] = number;
      }
    });
    setTimeout(() => {
      state.currentOrganisation = { ...state.currentOrganisation };
    }, 0);
  },
  CHANGE_NUMBER_DATA(state, payload) {
    const targetBusiness = state.currentOrganisation.businesses.find(b => b.id === payload.business_uid);
    if (targetBusiness) {
      targetBusiness.emoji = payload.emoji;
      targetBusiness.name = payload.name;
    }
  },
  CHANGE_ORGANISATION_DATA(state, payload) {
    state.currentOrganisation.logo = payload.logo;
    state.currentOrganisation.name = payload.name;
  },
  ORGANISATION_INITIALIZED(state, status) {
    state.initialized = status;
  },
  ORGANISATION_LIST_SET_LOADING(state) {
    state.organisationListLoading = true;
  },
  ORGANISATION_LIST_SET_DATA(state, payload) {
    state.organisationList = payload;
    state.organisationListLoading = false;
    state.organisationListLastUpdateTime = Date.now();
  },
  CURRENT_ORGANISATION_SET_LOADING(state) {
    state.currentOrganisationLoading = true;
  },
  CURRENT_ORGANISATION_SET_DATA(state, payload) {
    // START proccessing contact imports
    if (payload.contacts_imports) {
      payload.contacts_imports.forEach((ci) => {
        const oldImport = {
          id: ci.id,
          type: 'import',
          icon: SBIconList.ACTION_IMPORT,
          startDate: ci.created_at || Date.now(),
          stats: ci.progress,
          progress: ci.progress.total_contacts ? Math.floor((ci.progress.added_contacts + ci.progress.duplicated_contacts + ci.progress.failed_contacts.invalid_phone_format + ci.progress.failed_contacts.other) / ci.progress.total_contacts * 100) : 0,
        };
        if (ci.state === 'Finished') {
          oldImport.title = 'Contacts imported';
          oldImport.subtitle = `${window.vueFilters.bigDigits(ci.progress.added_contacts + ci.progress.duplicated_contacts + ci.progress.failed_contacts.invalid_phone_format + ci.progress.failed_contacts.other)} of ${window.vueFilters.bigDigits(ci.progress.total_contacts)}`;
          oldImport.state = ProgressStates.FINISHED;
        } else if (ci.state === 'Running') {
          oldImport.title = 'Importing contacts';
          oldImport.subtitle = `${window.vueFilters.bigDigits(ci.progress.added_contacts + ci.progress.duplicated_contacts + ci.progress.failed_contacts.invalid_phone_format + ci.progress.failed_contacts.other)} of ${window.vueFilters.bigDigits(ci.progress.total_contacts)}`;
          oldImport.state = ProgressStates.RUNNING;
        } else if (ci.state === 'Paused') {
          oldImport.title = 'Importing paused';
          oldImport.subtitle = `${window.vueFilters.bigDigits(ci.progress.added_contacts + ci.progress.duplicated_contacts + ci.progress.failed_contacts.invalid_phone_format + ci.progress.failed_contacts.other)} of ${window.vueFilters.bigDigits(ci.progress.total_contacts)}`;
          oldImport.state = ProgressStates.PAUSED;
        } else if (ci.state === 'Aborted') {
          oldImport.title = 'Importing paused';
          oldImport.subtitle = 'Something went wrong';
          oldImport.state = ProgressStates.FAILED;
        }

        state.progressActions[ci.id] = oldImport;
      });
      state.progressActions = { ...state.progressActions };

      delete payload.contacts_imports;
    }

    // START proccessing broadcasts
    if (payload.broadcasts) {
      payload.broadcasts.forEach((b) => {
        const oldBroadcast = {
          id: b.id,
          numberId: b.business_id,
          type: 'broadcast',
          icon: SBIconList.BROADCAST,
          startDate: b.created_at || Date.now(),
          stats: b.progress,
          progress: b.progress.total ? Math.floor(b.progress.sent / b.progress.total * 100) : 0,
        };
        let addToSend = 0;
        ['contact_unsubscribed', 'invalid_phone', 'contact_blocked'].forEach((key) => { addToSend += Number(b.progress.failed[key]) || 0; });
        if (b.state === 'Finished') {
          oldBroadcast.title = 'Broadcast sent';
          oldBroadcast.subtitle = `${window.vueFilters.bigDigits(Number(b.progress.sent) + addToSend)} of ${window.vueFilters.bigDigits(b.progress.total)}`;
          oldBroadcast.state = ProgressStates.FINISHED;
        } else if (b.state === 'Running') {
          oldBroadcast.title = 'Sending broadcast';
          oldBroadcast.subtitle = `${window.vueFilters.bigDigits(Number(b.progress.sent) + addToSend)} of ${window.vueFilters.bigDigits(b.progress.total)}`;
          oldBroadcast.state = ProgressStates.RUNNING;
        } else if (b.state === 'Paused') {
          oldBroadcast.title = 'Broadcast paused';
          oldBroadcast.subtitle = `${window.vueFilters.bigDigits(Number(b.progress.sent) + addToSend)} of ${window.vueFilters.bigDigits(b.progress.total)}`;
          oldBroadcast.state = ProgressStates.PAUSED;
        } else if (b.state === 'Aborted') {
          oldBroadcast.title = 'Broadcast paused';
          oldBroadcast.subtitle = 'Something went wrong';
          oldBroadcast.state = ProgressStates.FAILED;
        }

        state.progressActions[b.id] = oldBroadcast;
      });
      state.progressActions = { ...state.progressActions };

      delete payload.broadcasts;
    }

    // setting businessIds shorthand lookup as well
    const businessIds = [];
    payload.businesses.forEach((b) => { businessIds.push(b.id); });
    state.currentOrganisationBusinessIds = businessIds;
    // Test mock - just uncomment for testing
    // payload.businesses = [
    //   { "id": "1f9730b7-bcdc-4547-9d92-4caa70a60643", "name": "AI Number 2.0", "legal_merchant_name": null, "legal_entity_type": null, "email": "ivan@number.tm", "website": "https://number.tm", "logo": "", "plan": "Session Message (WhatsApp Session Message - AI Number - INBOUND USD per unit / month), 9 x Monthly subscription ($250 USD / month), Template messages (WhatsApp Message Template - HR USD per unit / month), Session Message (WhatsApp Session Message - AI Number - OUTBOUND USD per unit / month)", "plan_active": true, "slug": "number", "phone": "+13253077759", "unread_conversations": { "unassigned_unread": 0, "all_unread": 0, "user_unread": { "559a42d1-9662-430f-8664-8294bed16346": 0 } }, "address": "Ulica BB", "about": "Ovo je tesni number account.", "description": "Ovo je tesni number account.", "available": false },
    //   { "id": "448867a5-e511-4ab8-aec9-9fd094ca8a7a", "name": "test", "legal_merchant_name": null, "legal_entity_type": null, "email": null, "website": null, "logo": "https://sendbee-dev.s3.amazonaws.com/a-captain-underpants-movie-is-on-the-way-03-e1482784107381.jpg", "plan": "1 x Monthly subscription ($250 USD / month), 1 x Template messages ($0.04 USD / month)", "plan_active": false, "slug": "test", "phone": "+1234567893", "unread_conversations": { "unassigned_unread": 0, "all_unread": 0, "user_unread": { "559a42d1-9662-430f-8664-8294bed16346": 0 } }, "address": "test", "about": "", "description": "", "available": false },
    //   { "id": "1f9730b7-bhdc-4547-9d92-4caa70a60643", "name": "AI Number", "legal_merchant_name": null, "legal_entity_type": null, "email": "ivan@number.tm", "website": "https://number.tm", "logo": "", "plan": "Session Message (WhatsApp Session Message - AI Number - INBOUND USD per unit / month), 9 x Monthly subscription ($250 USD / month), Template messages (WhatsApp Message Template - HR USD per unit / month), Session Message (WhatsApp Session Message - AI Number - OUTBOUND USD per unit / month)", "plan_active": true, "slug": "number", "phone": "+13253077759", "unread_conversations": { "unassigned_unread": 0, "all_unread": 0, "user_unread": { "559a42d1-9662-430f-8664-8294bed16346": 0 } }, "address": "Ulica BB", "about": "Ovo je tesni number account.", "description": "Ovo je tesni number account.", "available": false },
    //   { "id": "1f9730b7-bcgjsdc-4547-9d92-4caa70a60643", "name": "AI Number", "legal_merchant_name": null, "legal_entity_type": null, "email": "ivan@number.tm", "website": "https://number.tm", "logo": "", "plan": "Session Message (WhatsApp Session Message - AI Number - INBOUND USD per unit / month), 9 x Monthly subscription ($250 USD / month), Template messages (WhatsApp Message Template - HR USD per unit / month), Session Message (WhatsApp Session Message - AI Number - OUTBOUND USD per unit / month)", "plan_active": true, "slug": "number", "phone": "+13253077759", "unread_conversations": { "unassigned_unread": 0, "all_unread": 0, "user_unread": { "559a42d1-9662-430f-8664-8294bed16346": 0 } }, "address": "Ulica BB", "about": "Ovo je tesni number account.", "description": "Ovo je tesni number account.", "available": false },
    //   { "id": "1f9730b7-bcdcsfg,-4547-9d92-4caa70a60643", "name": "AI Number", "legal_merchant_name": null, "legal_entity_type": null, "email": "ivan@number.tm", "website": "https://number.tm", "logo": "", "plan": "Session Message (WhatsApp Session Message - AI Number - INBOUND USD per unit / month), 9 x Monthly subscription ($250 USD / month), Template messages (WhatsApp Message Template - HR USD per unit / month), Session Message (WhatsApp Session Message - AI Number - OUTBOUND USD per unit / month)", "plan_active": true, "slug": "number", "phone": "+13253077759", "unread_conversations": { "unassigned_unread": 0, "all_unread": 0, "user_unread": { "559a42d1-9662-430f-8664-8294bed16346": 0 } }, "address": "Ulica BB", "about": "Ovo je tesni number account.", "description": "Ovo je tesni number account.", "available": false },
    //   { "id": "1f9730b7-bcdc-4547cbn.-9d92-4caa70a60643", "name": "AI Number", "legal_merchant_name": null, "legal_entity_type": null, "email": "ivan@number.tm", "website": "https://number.tm", "logo": "", "plan": "Session Message (WhatsApp Session Message - AI Number - INBOUND USD per unit / month), 9 x Monthly subscription ($250 USD / month), Template messages (WhatsApp Message Template - HR USD per unit / month), Session Message (WhatsApp Session Message - AI Number - OUTBOUND USD per unit / month)", "plan_active": true, "slug": "number", "phone": "+13253077759", "unread_conversations": { "unassigned_unread": 0, "all_unread": 0, "user_unread": { "559a42d1-9662-430f-8664-8294bed16346": 0 } }, "address": "Ulica BB", "about": "Ovo je tesni number account.", "description": "Ovo je tesni number account.", "available": false },
    //   { "id": "1f9730b7-bcdc-4547-9d92-vmn4caa70a60643", "name": "AI Number", "legal_merchant_name": null, "legal_entity_type": null, "email": "ivan@number.tm", "website": "https://number.tm", "logo": "", "plan": "Session Message (WhatsApp Session Message - AI Number - INBOUND USD per unit / month), 9 x Monthly subscription ($250 USD / month), Template messages (WhatsApp Message Template - HR USD per unit / month), Session Message (WhatsApp Session Message - AI Number - OUTBOUND USD per unit / month)", "plan_active": true, "slug": "number", "phone": "+13253077759", "unread_conversations": { "unassigned_unread": 0, "all_unread": 0, "user_unread": { "559a42d1-9662-430f-8664-8294bed16346": 0 } }, "address": "Ulica BB", "about": "Ovo je tesni number account.", "description": "Ovo je tesni number account.", "available": false },
    //   { "id": "1f9730b7-bcdc-4547-9d92-4caa<bb70a60643", "name": "AI Number", "legal_merchant_name": null, "legal_entity_type": null, "email": "ivan@number.tm", "website": "https://number.tm", "logo": "", "plan": "Session Message (WhatsApp Session Message - AI Number - INBOUND USD per unit / month), 9 x Monthly subscription ($250 USD / month), Template messages (WhatsApp Message Template - HR USD per unit / month), Session Message (WhatsApp Session Message - AI Number - OUTBOUND USD per unit / month)", "plan_active": true, "slug": "number", "phone": "+13253077759", "unread_conversations": { "unassigned_unread": 0, "all_unread": 0, "user_unread": { "559a42d1-9662-430f-8664-8294bed16346": 0 } }, "address": "Ulica BB", "about": "Ovo je tesni number account.", "description": "Ovo je tesni number account.", "available": false },
    //   { "id": "1f9730b7-bcdc-4547-9d92-4caa70a6gaer0643", "name": "AI Number", "legal_merchant_name": null, "legal_entity_type": null, "email": "ivan@number.tm", "website": "https://number.tm", "logo": "", "plan": "Session Message (WhatsApp Session Message - AI Number - INBOUND USD per unit / month), 9 x Monthly subscription ($250 USD / month), Template messages (WhatsApp Message Template - HR USD per unit / month), Session Message (WhatsApp Session Message - AI Number - OUTBOUND USD per unit / month)", "plan_active": true, "slug": "number", "phone": "+13253077759", "unread_conversations": { "unassigned_unread": 0, "all_unread": 0, "user_unread": { "559a42d1-9662-430f-8664-8294bed16346": 0 } }, "address": "Ulica BB", "about": "Ovo je tesni number account.", "description": "Ovo je tesni number account.", "available": false },
    //   { "id": "1f9730b7-bcdc-4547-9d92-4caa70a606wF43", "name": "AI Number", "legal_merchant_name": null, "legal_entity_type": null, "email": "ivan@number.tm", "website": "https://number.tm", "logo": "", "plan": "Session Message (WhatsApp Session Message - AI Number - INBOUND USD per unit / month), 9 x Monthly subscription ($250 USD / month), Template messages (WhatsApp Message Template - HR USD per unit / month), Session Message (WhatsApp Session Message - AI Number - OUTBOUND USD per unit / month)", "plan_active": true, "slug": "number", "phone": "+13253077759", "unread_conversations": { "unassigned_unread": 0, "all_unread": 0, "user_unread": { "559a42d1-9662-430f-8664-8294bed16346": 0 } }, "address": "Ulica BB", "about": "Ovo je tesni number account.", "description": "Ovo je tesni number account.", "available": false },
    //   { "id": "1f9730b7-bcdc-4547-9d92-4caa70a6064wg3", "name": "AI Number", "legal_merchant_name": null, "legal_entity_type": null, "email": "ivan@number.tm", "website": "https://number.tm", "logo": "", "plan": "Session Message (WhatsApp Session Message - AI Number - INBOUND USD per unit / month), 9 x Monthly subscription ($250 USD / month), Template messages (WhatsApp Message Template - HR USD per unit / month), Session Message (WhatsApp Session Message - AI Number - OUTBOUND USD per unit / month)", "plan_active": true, "slug": "number", "phone": "+13253077759", "unread_conversations": { "unassigned_unread": 0, "all_unread": 0, "user_unread": { "559a42d1-9662-430f-8664-8294bed16346": 0 } }, "address": "Ulica BB", "about": "Ovo je tesni number account.", "description": "Ovo je tesni number account.", "available": false },
    // ],
    state.currentOrganisation = payload;
    state.currentOrganisationLoading = false;
  },
  UPDATE_NUMBER_NAME(state, payload) {
    const number = state.currentOrganisation.businesses.find(business => business.id === payload.uid);
    number.name = payload.name;
    number.emoji = payload.emoji;
  },
  ORGANISATION_MEMBERS_SET_LOADING(state) {
    state.organisationMembersLoading = true;
  },
  /** @deprecated */
  ORGANISATION_MEMBERS_SET_DATA(state, data) {
    state.organisationMembers = data;
    // direct lookup by ID
    const membersLookup = {};
    data.forEach((m) => {
      membersLookup[m.id] = m;
    });
    state.organisationMembersLookup = membersLookup;
    // legacy approach, set loading to false
    state.organisationMembersLoading = false;
  },
  /**
   * Mutations for members data structure.
   * Stores members per type key.
   * @param {*} state Store state
   * @param {*} data Members data
   */
  ORGANISATION_MEMBERS_SET_DATA2(state, payload) {
    if (payload.type) {
      state.organisationMembers2[payload.type] = payload.data;
    } else {
      Object.values(memberTypes).forEach((type) => {
        state.organisationMembers2[type] = payload.data.filter(memberFilterMethods[type]);
      });
    }

    // TODO if neccessary do a lookup for each type like in the deprecated mutation
  },
  ORGANISATION_TEAMS_SET_LOADING(state) {
    state.organisationTeamsLoading = true;
  },
  ORGANISATION_TEAMS_SET_DATA(state, data) {
    state.organisationTeams = data;
    state.organisationTeamsLoading = false;
  },
  UPDATE_MEMBER_AVAILABILITY(state, { memberId, isAvailable }) {
    if (state.organisationMembersLookup && state.organisationMembersLookup[memberId]) {
      state.organisationMembersLookup[memberId].available = isAvailable;
    }
  },
  UPDATE_BUSINESS_AVAILABILITY(state, { businessId, isAvailable }) {
    const business = state.currentOrganisation.businesses.find(b => b.id === businessId);

    if (business) {
      business.available = isAvailable;
    }
  },
  SET_USER_AVAILABILITY_ON_CURRENT_ORGANISATION(state, payload) {
    state.currentOrganisation.user_availability.available = payload;
  },
  SET_SHOW_SPLASH(state) {
    state.showSplash = true;
    state.progress = 0;
    state.message = '';
    state.finalizeSplash = false;
    // Prevent splash from closing earlier than min time expires
    setTimeout(() => { state.splashMinDurationFinished = true; }, process.env.VUE_APP_MIN_SPLASH_TIME);
  },
  SET_HIDE_SPLASH(state) {
    state.showSplash = false;
    state.progress = 0;
    state.message = '';
    state.splashTotal = 0;
    state.splashMinDurationFinished = false;
    state.finalizeSplash = false;
    localStorage.removeItem('forceSplashMessage');
  },
  SET_SPLASH_MESSAGE(state, message) {
    if (localStorage.getItem('forceSplashMessage')) {
      state.splashMessage = localStorage.getItem('forceSplashMessage');
    } else {
      state.splashMessage = message;
    }
  },
  INCREASE_SPLASH_PROGRESS(state) {
    state.splashTotal++;
  },
  FINALIZE_SPLASH(state) {
    state.finalizeSplash = true;
    localStorage.removeItem('forceSplashMessage');
  },
  SET_STATISTICS(state, payload) {
    Vue.set(state.statistics, payload.merchant_id, payload.data);

    // reset local stats
    if (state.localStatsOffsetCount[payload.merchant_id]) {
      state.localStatsOffsetCount[payload.merchant_id] = 0;
    }
    if (state.localStatsOffsetIds[payload.merchant_id]) {
      state.localStatsOffsetIds[payload.merchant_id] = [];
    }
    if (state.localStatsOffsetMyChatCount[payload.merchant_id]) {
      state.localStatsOffsetMyChatCount[payload.merchant_id] = 0;
    }

    // Reset local ofssets and counters for number
    delete state.statisticLocalData[payload.merchant_id];
    delete state.localStatsOffsetCount[payload.merchant_id];
    delete state.localStatsOffsetIds[payload.merchant_id];
    delete state.localStatsOffsetMyChatCount[payload.merchant_id];
  },
  CLEAR_STATISTICS(state) {
    state.statistics = {};
  },
  API_ERROR(state, payload) {
    if (payload) {
      state.apiError = payload;
    }
  },
  REMOVE_MEMBER_FROM_ORGANISATION(state, payload) {
    state.organisationMembers = state.organisationMembers.filter(member => member.id !== payload.user_uid);
  },
  UPDATE_BUSINESS_TIMEZONE(state, payload) {
    const targetBusiness = state.currentOrganisation.businesses.find(business => business.id === payload.businessId);
    targetBusiness.time_zone[0] = payload.timezone;
    state.currentOrganisation = { ...state.currentOrganisation };
  },
  UPDATE_CURRENT_ORGANISATION(state, payload) {
    state.currentOrganisation.name = payload.data.get('name');
    if (payload.newLogoUrl) {
      state.currentOrganisation.logo = payload.newLogoUrl;
    }
  },
  SET_CURRENT_NUMBER(state, numberId) {
    state.currentNumber = numberId;
  },
  UPDATE_UNREAD_PER_NUMBER(state, payload) {
    state.statistics[payload.numberId].open.all_unread = payload.counter >= 0 ? payload.counter : 0;
    state.statistics[payload.numberId].open.user_unread[payload.userId] = payload.userCounter >= 0 ? payload.userCounter : 0;
    state.statistics = { ...state.statistics };
  },
  UPDATE_MEMBERS_WITH_NUMBER(state, payload) {
    const membersIds = payload.members.map(member => member[0]);
    state.organisationMembers.forEach((member) => {
      if (member.businesses.includes(payload.numberId[0]) && !membersIds.includes(member.id)) {
        const removeBusinessIndex = member.businesses.findIndex(business => business === payload.numberId[0]);
        member.businesses.splice(removeBusinessIndex, 1);
      } else if (!member.businesses.includes(payload.numberId[0]) && membersIds.includes(member.id)) {
        member.businesses.push(payload.numberId[0]);
      }
    });
  },
  INCREMENT_STATISTIC_LOCAL_DATA(state, payload) {
    if (!state.statisticLocalData[payload.businessId]) {
      state.statisticLocalData[payload.businessId] = {};
    }
    state.statisticLocalData[payload.businessId][payload.conversationId] = 0;
    // ++state.statistics[payload.businessId].open.all_unread;

    if (!state.localStatsOffsetIds[payload.businessId]) {
      state.localStatsOffsetIds[payload.businessId] = [];
    }
    if (!state.localStatsOffsetCount[payload.businessId]) {
      state.localStatsOffsetCount[payload.businessId] = 0;
    }
    if (!state.localStatsOffsetMyChatCount[payload.businessId]) {
      state.localStatsOffsetMyChatCount[payload.businessId] = 0;
    }
    const conversationIsInTheList = !!payload.allConversationsList.find(c => c.id === payload.conversationId);
    if ( // Situation when the conversation is somewhere back in the past and the user still doesn't have it loaded in the conversation list
      !conversationIsInTheList &&
      !state.localStatsOffsetIds[payload.businessId].includes(payload.conversationId)
    ) {
      state.localStatsOffsetCount[payload.businessId]++;
    } else if (
      conversationIsInTheList &&
      !state.localStatsOffsetIds[payload.businessId].includes(payload.conversationId)
    ) {
      state.localStatsOffsetIds[payload.businessId].push(payload.conversationId);
    }

    if (payload.myChat) {
      state.localStatsOffsetMyChatCount[payload.businessId]++;
    }

    state.localStatsOffsetCount = { ...state.localStatsOffsetCount };
    state.localStatsOffsetIds = { ...state.localStatsOffsetIds };
    state.localStatsOffsetMyChatCount = { ...state.localStatsOffsetMyChatCount };
    state.statisticLocalData = { ...state.statisticLocalData };
  },
  DECREMENT_STATISTIC_LOCAL_DATA(state, payload) {
    if (!state.statisticLocalData[payload.businessId]) {
      state.statisticLocalData[payload.businessId] = {};
    }
    state.statisticLocalData[payload.businessId][payload.conversationId] = 0;
    // if (state.statistics[payload.businessId].open.all_unread > 0) {
    //   --state.statistics[payload.businessId].open.all_unread;
    // }

    if (!state.localStatsOffsetIds[payload.businessId]) {
      state.localStatsOffsetIds[payload.businessId] = [];
    }
    if (!state.localStatsOffsetCount[payload.businessId]) {
      state.localStatsOffsetCount[payload.businessId] = 0;
    }
    if (!state.localStatsOffsetMyChatCount[payload.businessId]) {
      state.localStatsOffsetMyChatCount[payload.businessId] = 0;
    }
    // const conversationIsInTheList = !!payload.allConversationsList.find(c => c.id === payload.conversationId);
    // if (state.localStatsOffsetIds[payload.businessId].includes(payload.conversationId)) {
    //   state.localStatsOffsetIds[payload.businessId].filter(id => id !== payload.conversationId);
    // } else {
    //   state.localStatsOffsetCount[payload.businessId]++;
    // }

    if ( // Situation when the conversation is somewhere back in the past and the user still doesn't have it loaded in the conversation list
      state.localStatsOffsetIds[payload.businessId].includes(payload.conversationId)
    ) {
      state.localStatsOffsetIds[payload.businessId] = state.localStatsOffsetIds[payload.businessId].filter(id => id !== payload.conversationId);
    } else {
      state.localStatsOffsetCount[payload.businessId]--;
    }

    if (payload.myChat) {
      state.localStatsOffsetMyChatCount[payload.businessId]--;
    }

    state.localStatsOffsetCount = { ...state.localStatsOffsetCount };
    state.localStatsOffsetIds = { ...state.localStatsOffsetIds };
    state.localStatsOffsetMyChatCount = { ...state.localStatsOffsetMyChatCount };
    state.statisticLocalData = { ...state.statisticLocalData };
  },
  UPDATE_STATISTIC_LOCAL_DATA(state, payload) {
    if (
      payload.unseenMessages === 0 &&
      (
        (payload.myConversation && payload.seenPayload && payload.seenPayload.conversation && payload.seenPayload.conversation.assignment_seen) ||
        (!payload.myConversation && payload.seenPayload && payload.seenPayload.conversation && payload.seenPayload.conversation.seen)
      )
    ) {
      if (state.statistics[payload.businessId].open.all_unread > 0) {
        --state.statistics[payload.businessId].open.all_unread;
      }
      // decrease user counter if needed
      if (
        payload.myConversation
      ) {
        if (state.statistics[payload.businessId].open.user_unread[payload.myId] > 0) {
          --state.statistics[payload.businessId].open.user_unread[payload.myId];
        }
      }
    }

    if (!state.statisticLocalData[payload.businessId]) {
      state.statisticLocalData[payload.businessId] = {};
    }
    if (!state.statisticLocalData[payload.businessId][payload.conversationId]) {
      state.statisticLocalData[payload.businessId][payload.conversationId] = 0;
    }

    // if unseen messages === 1 then this means this is the first unseen message and conversation must be counted as unread. If more than 1 then just ignore.
    if (!payload.skipCount && payload.unseenMessages === 1 && state.statistics[payload.businessId]) {
      ++state.statistics[payload.businessId].open.all_unread;
      if (payload.myConversation) {
        if (!state.statistics[payload.businessId].open.user_unread[payload.myId]) {
          state.statistics[payload.businessId].open.user_unread[payload.myId] = 0;
        }
        ++state.statistics[payload.businessId].open.user_unread[payload.myId];
      }
    }
    state.statisticLocalData[payload.businessId][payload.conversationId] = payload.unseenMessages >= 0 ? payload.unseenMessages : 0;

    state.statisticLocalData = { ...state.statisticLocalData };
    state.statistics = { ...state.statistics };
  },
  RESET_LOCAL_COUNTER(state, payload) {
    state.statisticLocalData[payload.businessId][payload.conversationId] = 0;
  },
  CLEAR_STATISTIC_LOCAL_DATA(state) {
    state.statisticLocalData = {};
  },
  SET_INTEGRATIONS_DATA(state, integrationsData) {
    state.integrationsData = integrationsData;
    const numberIntegrationMap = {};
    const numberIntegrationData = {};
    integrationsData.forEach((integration) => {
      if (integration.category === 'inbox') {
        integration.business.forEach((number) => {
          if (!Object.keys(numberIntegrationMap).includes(number.uid)) {
            numberIntegrationMap[number.uid] = [];
            numberIntegrationData[number.uid] = {};
          }

          if (!numberIntegrationMap[number.uid].includes(integration.code)) {
            numberIntegrationMap[number.uid].push(integration.code);
            if (!numberIntegrationData[number.uid][integration.code]) {
              numberIntegrationData[number.uid][integration.code] = [];
            }
            numberIntegrationData[number.uid][integration.code].push(number);
          }
        });
      }
    });

    state.numberIntegrationMap = numberIntegrationMap;
    state.numberIntegrationData = numberIntegrationData;
  },
  SET_INTEGRATIONS_REGISTRY_DATA(state, integrationsRegistryData) {
    state.integrationsRegistryData = [...integrationsRegistryData];
  },
  SET_CHANNELS_DATA(state, channelsDataRegistry) {
    state.channelsDataRegistry = channelsDataRegistry;
  },
  FORCE_RESYNC(state) {
    state.forceResync++;
  },
  MARK_INVOICE_AS_PAID(state, data) {
    if (data.subject === 'account_subscription') {
      state.organisationList.forEach((organisation) => {
        if (Array.isArray(organisation.activate_items)) {
          const targetInvoice = organisation.activate_items.find(invoice => invoice.id === data.invoice_id);
          if (targetInvoice) {
            targetInvoice.status = 'paid';
          }
        }
      });

      if (Array.isArray(state.currentOrganisation.activate_items)) {
        const targetInvoice = state.currentOrganisation.activate_items.find(invoice => invoice.id === data.invoice_id);
        if (targetInvoice) {
          targetInvoice.status = 'paid';
        }
      }
    }
  },
  DEACTIVATE_ORGANISATION(state, data) {
    let targetOrganisationBlocked = false;
    state.organisationList.forEach((organisation) => {
      if (Array.isArray(organisation.activate_items)) {
        const targetInvoice = organisation.activate_items.find(invoice => invoice.id === data.invoice_id);
        if (targetInvoice) {
          targetInvoice.status = 'failed';
          organisation.should_reactivate_account = true;
          targetOrganisationBlocked = true;
        }
      }
    });

    if (Array.isArray(state.currentOrganisation.activate_items)) {
      const targetInvoice = state.currentOrganisation.activate_items.find(invoice => invoice.id === data.invoice_id);
      if (targetInvoice) {
        targetInvoice.status = 'failed';
        state.currentOrganisation.should_reactivate_account = true;
      }
    }

    if (!targetOrganisationBlocked) {
      state.reloadOrganisationList++;
    }
  },
  PAYMENT_UPDATE(state, data) {
    state.updateBillingPage++;
    state.paymentUpdate = data;
  },
  UPDATE_PROGRESS_ACTION(state, data) {
    let noChangeCounter = !state.progressActions[data.progressId] || !state.progressActions[data.progressId].noChangeCounter ? 0 : state.progressActions[data.progressId].noChangeCounter;
    if (
      state.progressActions &&
      state.progressActions[data.progressId] &&
      isEqual({ ...state.progressActions[data.progressId].stats }, { ...data.stats })
    ) {
      noChangeCounter++;
    } else {
      noChangeCounter = 0;
    }
    // In case the progress is finished, the title and subtitle should wait for the progress bar to reach 100% and then update. This happens in 500ms needed for the progress animation to finish.
    if (data.data.progress === 100 && state.progressActions[data.progressId] && state.progressActions[data.progressId].progress < 100) {
      const title = data.data.title;
      const subtitle = data.data.subtitle;
      delete data.data.title;
      delete data.data.subtitle;
      setTimeout(() => {
        state.progressActions[data.progressId] = { ...state.progressActions[data.progressId], ...{ title, subtitle }, ...{ noChangeCounter } };
      }, 500);
    }
    if (state.progressActions[data.progressId] && state.progressActions[data.progressId].state === ProgressStates.PAUSING && data.data.state !== ProgressStates.PAUSED) {
      delete data.data.state;
    }
    state.progressActions[data.progressId] = { ...state.progressActions[data.progressId], ...data.data, ...{ noChangeCounter } };
  },
  SET_IMPORT_ACTION(state, payload) {
    state.progressActions[payload.import_id] = {
      id: payload.import_id,
      type: 'import',
      icon: SBIconList.ACTION_IMPORT,
      title: 'Importing contacts',
      subtitle: 'Preparing...',
      progress: 0,
      state: ProgressStates.RUNNING,
      startDate: Date.now(),
      stats: {},
    };
    state.progressActions = { ...state.progressActions };
  },
  SET_BROADCAST_ACTION(state, payload) {
    state.progressActions[payload.broadcast_id] = {
      id: payload.broadcast_id,
      numberId: payload.numberId,
      type: 'broadcast',
      icon: SBIconList.BROADCAST,
      title: 'Sending broadcast',
      subtitle: 'Preparing...',
      progress: 0,
      state: ProgressStates.RUNNING,
      startDate: Date.now(),
      stats: {},
    };
    state.progressActions = { ...state.progressActions };
  },
  PAUSE_ACTION(state, payload) {
    state.progressActions[payload.actionId].title = payload.title;
    if (payload.pausingState) {
      state.progressActions[payload.actionId].state = payload.pausingState;
    } else {
      state.progressActions[payload.actionId].state = ProgressStates.PAUSED;
    }
    state.progressActions = { ...state.progressActions };
  },
  CONTINUE_ACTION(state, payload) {
    state.progressActions[payload.actionId].title = payload.title;
    state.progressActions[payload.actionId].state = ProgressStates.RUNNING;
  },
  CLOSE_ACTION(state, payload) {
    delete state.progressActions[payload.actionId];
    state.progressActions = { ...state.progressActions };
  },
  FAIL_ACTION(state, payload) {
    state.progressActions[payload.actionId].title = payload.title;
    state.progressActions[payload.actionId].subtitle = 'Something went wrong';
    state.progressActions[payload.actionId].state = ProgressStates.FAILED;
  },
  REMOVE_INTEGRATION(state, payload) {
    const integration = state.integrationsRegistryData.find(integration => integration.code === payload.type);
    if (payload.numberId && integration) { // remove all items from the integration
      integration.organisation_specific_data.business[payload.numberId] = [];
    } else if (integration) { // remove single integration item
      integration.organisation_specific_data.business[payload.frontChannel.numberId] = integration.organisation_specific_data.business[payload.frontChannel.numberId].filter(i => i.integration_id !== payload.frontChannel.integration_id);
    }
  },
  CLEAR_FEATURES(state) {
    state.features = {};
  },
  SET_FEATURES(state, payload) {
    state.features = { ...payload };
  },
  SET_UNREAD_COUNTER(state, counter) {
    state.totalUnreadConversations = counter;
  },
  SET_ORGANISATION_AI_ASSISTANTS(state, payload) {
    state.aiAssistants = payload;
  },
  UPDATE_LOCAL_ASSISTANT(state, payload) {
    const targetAssistant = state.aiAssistants.find(assistant => assistant.member_id === payload.member_id);
    if (targetAssistant) {
      targetAssistant.name = payload.name;
      targetAssistant.avatar = payload.avatar;
    }

    // also, update it in the organisation members - organisation/currentOrganisationMembers
    const targetMemberOrg = state.organisationMembers.find(member => member.id === payload.member_id);
    if (targetMemberOrg) {
      targetMemberOrg.name = payload.name;
      targetMemberOrg.avatar = payload.avatar;
    }
  },
  SET_WEB_WIDGETS(state, payload) {
    state.webWidgets = payload;
  },
};

export default mutations;
